import { appAxios } from "@/core/utils/appAxios";
import { APIResponse } from "@/shared/api-contract/api-contract";
import { useToast } from "primevue/usetoast";
import { Options, Vue, setup } from "vue-class-component";
import { Emit, Model, Ref } from "vue-property-decorator";

@Options({
    components: {},
})
export class UploadCmrPopup extends Vue {
    @Model("_orderId", { required: true, default: 83343 })
    orderId!: number | string;
    @Model("_vehiclesId", { required: true, default: [113314] })
    vehicles!: (number | string)[];
    @Ref()
    fileInput!: HTMLInputElement;

    toast = setup(useToast);

    isDragging = false;
    loaded: number | null = null;
    total: number | null = null;
    uploadProgress: number | null = null;
    files: File[] = [];
    @Emit("closePopup")
    closePopup() {
        this.$emit("closePopup");
    }
    deleteFile(id: number | string) {
        this.files = this.files.filter((el, i) => i !== id);
    }

    openFileInput() {
        this.fileInput.click();
    }

    truncateFileName(fileName, maxLength) {
        return fileName.length > maxLength
            ? fileName.substring(0, maxLength - 3) + "..."
            : fileName;
    }

    handleFileChange(event: Event) {
        this.uploadProgress = null;
        if (!(event.target as HTMLInputElement).files) return;
        const files = (event.target as HTMLInputElement)?.files;
        if (!files?.length) return;
        const arr: File[] = [];
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const replaceFileIndex = this.files.findIndex((f) => f.name === file.name);
            if (replaceFileIndex >= 0) {
                this.files[replaceFileIndex] = file;
            } else {
                arr.push(file);
            }
        }
        this.files = [...this.files, ...arr];
    }

    handleDragOver() {
        this.isDragging = true;
    }

    handleDragEnter() {
        this.isDragging = true;
    }

    handleDragLeave() {
        this.isDragging = false;
    }

    handleDrop(event: DragEvent) {
        event.preventDefault();
        this.isDragging = false;

        const files = event.dataTransfer?.files;
        if (files && files.length > 0) {
            this.handleFileChange({ target: { files } } as unknown as Event);
        }
    }

    /* API Connectivity --------------------------------------------------------------------------------------------- */
    async fetchUploadCmr() {
        if (!this.files.length) return;
        let total = 0;
        this.files.forEach((f) => {
            total += f.size;
        });
        this.total = total;
        Promise.allSettled(
            this.files.map((el, i) => {
                return appAxios.value.put<APIResponse<void>>(
                    `/client/web/orders/${this.orderId}/vehicles/${this.vehicles.join(
                        ",",
                    )}/cmr-document`,
                    el,
                    {
                        headers: {
                            "Content-Type": "application/pdf",
                        },
                        onUploadProgress: (progressEvent) => {
                            this.loaded = this.loaded
                                ? progressEvent.loaded
                                : this.loaded + progressEvent.loaded;
                            if (!this.loaded || !this.total) return;
                            this.uploadProgress = Math.round(
                                (this.loaded / this.total) * 100,
                            );
                        },
                    },
                );
            }),
        )
            .then((response) => {
                this.toast.add({
                    severity: "info",
                    summary: `File${
                        response.length > 1 ? "s" : ""
                    } uploaded successfully`,
                    life: 3000,
                });
                console.log(
                    `File${response.length > 1 ? "s" : ""} uploaded successfully`,
                    response,
                );
            })
            .catch((error) => {
                console.error("Error uploading file:", error);
            })
            .finally(() => {
                this.uploadProgress = 100;
                this.closePopup();
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            });
    }
}
